<template>
  <template v-if="isInit">
    <table class="tb-row">
      <colgroup>
        <col style="width:18%;"/>
        <col style="width:auto;"/>
        <col style="width:18%;"/>
        <col style="width:auto;"/>
      </colgroup>
      <tbody>
      <tr>
        <th>주소</th>
        <td colspan="3" class="last">
          <div style="line-height: 25px;">
            <input type="text" style="width: 20%;" maxlength="15" readonly v-model="zip"/>
            <btn :txt="'주소 검색'"
                 :size="'small'"
                 :color="'white'"
                 @click="btnAddrSrch_click"/>
          </div>
          <div class="mgt5" style="line-height: 25px;">
            <input type="text" style="width: 100%;" maxlength="15" readonly v-model="fcltyAddr"/>
          </div>
          <div class="mgt5">
            <input type="text" style="width: 100%;" placeholder="상세주소 입력" v-model="fcltyDpAddr"/>
          </div>
        </td>
      </tr>
      <tr>
        <th>전화번호</th>
        <td>
          <select style="width: 60px;"
                  v-model="fcltyTlno1">
            <option v-for="tlno in $cmmn.txt.tlnos"
                    :key="tlno"> {{ tlno }}</option>
          </select> -
          <input type="text"
                 style="width: 86px;"
                 maxlength="4"
                 v-model="fcltyTlno2"/> -
          <input type="text"
                 style="width: 86px;"
                 maxlength="4"
                 v-model="fcltyTlno3"/>
        </td>
        <th>팩스</th>
        <td class="last">
          <select style="width: 60px;"
                  v-model="fcltyFaxTlno1">
            <option v-for="tlno in $cmmn.txt.tlnos"
                    :key="tlno"> {{ tlno }}</option>
          </select> -
          <input type="text"
                 style="width: 86px;"
                 maxlength="4"
                 v-model="fcltyFaxTlno2"/> -
          <input type="text"
                 style="width: 86px;"
                 maxlength="4"
                 v-model="fcltyFaxTlno3"/>
        </td>
      </tr>
      <tr>
        <th>업태</th>
        <td>
          <input type="text" style="width: 100%;"
                 maxlength="20"
                 v-model="bizcndNm"/>
        </td>
        <th>종목</th>
        <td class="last">
          <input type="text" style="width: 100%;"
                 maxlength="20"
                 v-model="itemNm"/>
        </td>
      </tr>
      <tr>
        <th>시설이메일</th>
        <td colspan="3" class="last">
          <input  type="text" placeholder="이메일"
                  class="__left"
                  style="width:100px;padding-left: 5px;"
                  title="이메일"
                  maxlength="60"
                  v-model="taxbilRcpnEmail1"/>
          @
          <input type="text"
                 style="width:140px;"
                 maxlength="50"
                 :readonly="taxbilRcpnEmail3? true: false"
                 v-model="taxbilRcpnEmail2"/>
          <cd-selbx :cds="$cmmn.txt.emails"
                    :cd="taxbilRcpnEmail3"
                    :cd-txt="'val'"
                    :nm-txt="'lab'"
                    @select="selBxEmail_change"/>
        </td>
      </tr>
      <tr>
        <th>시설핸드폰번호</th>
        <td colspan="3" class="last">
          <select style="width: 60px;"
                  v-model="fcltyMbpnTlno1">
            <option v-for="mbpn in $cmmn.txt.mbpns"
                    :key="mbpn"> {{ mbpn }}</option>
          </select> -
          <input type="text"
                 style="width: 86px;"
                 maxlength="4"
                 v-model="fcltyMbpnTlno2"/> -
          <input type="text"
                 style="width: 86px;"
                 maxlength="4"
                 v-model="fcltyMbpnTlno3"/>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="layer-btn">
      <btn :txt="'취소'"
           :color="'white'"
           @click="btnCancl_click"/>
      <btn :txt="'변경'"
           :color="'purple'"
           @click="btnChng_click"/>
    </div>
  </template>
</template>

<script setup>
import {computed, defineEmits, defineProps, onMounted, ref} from "vue";
import {getStore, getUtils} from "@/utils/import";

const {$axios, $cmmn, $alert, $valid, $cmmnPopup} = getUtils();
const {$loading, $mber} = getStore();

const props = defineProps({
  fcltySn: {
    type: Number,
    required: true
  }
})

const emits = defineEmits(['close', 'chng-compt']);
const btnCancl_click = () => {
  close();
}

const close = () => {
  emits('close');
}

const fcltyTycd = ref('');
const fcltyDpTycd = ref('');
const sigunguCd = ref('');
const zip = ref('');
const fcltyAddr = ref('');
const fcltyDpAddr = ref('');
const bizcndNm = ref('');
const itemNm = ref('');

const fcltyTlno = computed(() => fcltyTlno1.value + '-' + fcltyTlno2.value + '-' + fcltyTlno3.value);
const fcltyTlno1 = ref('02');
const fcltyTlno2 = ref('');
const fcltyTlno3 = ref('');

const fcltyFaxTlno = computed(() => fcltyFaxTlno1.value + '-' + fcltyFaxTlno2.value + '-' + fcltyFaxTlno3.value);
const fcltyFaxTlno1 = ref('02');
const fcltyFaxTlno2 = ref('');
const fcltyFaxTlno3 = ref('');

const taxbilRcpnEmail = computed(() => taxbilRcpnEmail1.value.trim() + '@' + taxbilRcpnEmail2.value.trim());
const taxbilRcpnEmail1 = ref('');
const taxbilRcpnEmail2 = ref('');
const taxbilRcpnEmail3 = ref('');

const fcltyMbpnTlno = computed(() => fcltyMbpnTlno1.value + '-' + fcltyMbpnTlno2.value + '-' + fcltyMbpnTlno3.value);
const fcltyMbpnTlno1 = ref('010');
const fcltyMbpnTlno2 = ref('');
const fcltyMbpnTlno3 = ref('');

const getFcltyByFcltySn = async () => {
  const data = await $cmmn.fclty.getFcltyByFcltySn(props.fcltySn);
  fcltyTycd.value = data.fcltyTycd;
  fcltyDpTycd.value = data.fcltyDpTycd;
  sigunguCd.value = data.sigunguCd;
  zip.value = data.zip;
  fcltyAddr.value = data.fcltyAddr;
  fcltyDpAddr.value = data.fcltyDpAddr;
  bizcndNm.value = data.bizcndNm;
  itemNm.value = data.itemNm;

  setTlnoAndTaxbilRcpnEmail(data.fcltyTlno, data.fcltyFaxTlno, data.taxbilRcpnEmail, data.fcltyMbpnTlno);
}

/* 기존 번호, 이메일 셋팅 */
const setTlnoAndTaxbilRcpnEmail = (fcltyTlno, fcltyFaxTlno, taxbilRcpnEmail, fcltyMbpnTlno) => {
  if (fcltyTlno) {
    const fcltyTlnos =  fcltyTlno.split('-');
    fcltyTlno1.value = fcltyTlnos[0];
    if (fcltyTlnos.length > 0) fcltyTlno2.value = fcltyTlnos[1];
    if (fcltyTlnos.length > 1) fcltyTlno3.value = fcltyTlnos[2];
  }

  if (fcltyFaxTlno) {
    const fcltyFaxTlnos =  fcltyFaxTlno.split('-');
    fcltyFaxTlno1.value = fcltyFaxTlnos[0];
    if(fcltyFaxTlnos.length > 0) fcltyFaxTlno2.value = fcltyFaxTlnos[1];
    if(fcltyFaxTlnos.length > 1) fcltyFaxTlno3.value = fcltyFaxTlnos[2];
  }

  const taxbilEmails = taxbilRcpnEmail.split('@');
  taxbilRcpnEmail1.value = taxbilEmails[0];
  if (taxbilEmails.length > 1) {
    const email2 = taxbilEmails[1];

    taxbilRcpnEmail2.value = email2;
    const index = $cmmn.txt.emails.findIndex((email) => email == email2);
    if (index > -1) taxbilRcpnEmail2.value = email2;
  }

  if (fcltyMbpnTlno) {
    const fcltyMbpnTlnos =  fcltyMbpnTlno.split('-');
    fcltyMbpnTlno1.value = fcltyMbpnTlnos[0];
    if(fcltyMbpnTlnos.length > 0) fcltyMbpnTlno2.value = fcltyMbpnTlnos[1];
    if(fcltyMbpnTlnos.length > 1) fcltyMbpnTlno3.value = fcltyMbpnTlnos[2];
  }
}

const selBxEmail_change = (selCd) => {
  taxbilRcpnEmail3.value = selCd;
  taxbilRcpnEmail2.value = selCd;
};

const btnAddrSrch_click = () => {
  $cmmnPopup.postcodeShow(comptPostcode);
}

const comptPostcode = ({zip: setZip, adres: setAdres, sigunguCd: setSigunguCd}) => {
  sigunguCd.value = setSigunguCd;
  zip.value = setZip;
  fcltyAddr.value = setAdres;
}

const valid = () => {
  let isValid = true;
  let msg = '';

  if (isValid && !zip.value) {
    isValid = false;
    msg = '주소를 입력해주세요.';
  }

  if (isValid && !fcltyAddr.value) {
    isValid = false;
    msg = '주소를 입력해주세요.';
  }

  const isFcltyTlno = !fcltyTlno1.value || !fcltyTlno2.value || !fcltyTlno3.value;
  if (isValid && isFcltyTlno) {
    isValid = false;
    msg = '전화번호를 입력해주세요.';
  }

  /* 팩스번호는 필수가 아님 */
  /*const isFcltyFaxTlno = !fcltyFaxTlno1.value || !fcltyFaxTlno2.value || !fcltyFaxTlno3.value;
  if (isValid && isFcltyFaxTlno) {
    isValid = false;
    msg = '팩스를 입력해주세요.';
  }*/

  if (isValid && !bizcndNm.value) {
    isValid = false;
    msg = '업태를 입력해주세요.';
  }

  if (isValid && !itemNm.value) {
    isValid = false;
    msg = '종목을 입력해주세요.';
  }

  if (isValid && !$valid.email(taxbilRcpnEmail.value)) {
    isValid = false;
    msg = '올바른 이메일형식을 입력해주세요.';
  }

  const isFcltyMbpnTlno = !fcltyMbpnTlno1.value || !fcltyMbpnTlno2.value || !fcltyMbpnTlno3.value;
  if (isValid && isFcltyMbpnTlno) {
    isValid = false;
    msg = '시설핸드폰번호를 입력해주세요.';
  }

  return {isValid, msg};
}

const btnChng_click = async () => {
  try {
    $loading.on();

    const {isValid, msg} = valid();
    if (!isValid) {
      await $alert(msg);
      return false;
    }

    const modifyParams = {
      fcltySn: props.fcltySn,
      mberSn: $mber.mberSn,
      fcltyTycd: fcltyTycd.value,
      fcltyDpTycd: fcltyDpTycd.value,
      sigunguCd: sigunguCd.value,
      zip: zip.value,
      fcltyAddr: fcltyAddr.value,
      fcltyDpAddr: fcltyDpAddr.value,
      fcltyTlno: fcltyTlno.value,
      fcltyFaxTlno: fcltyFaxTlno.value,
      bizcndNm: bizcndNm.value,
      itemNm: itemNm.value,
      taxbilRcpnEmail: taxbilRcpnEmail.value,
      fcltyMbpnTlno: fcltyMbpnTlno.value,
    }

    await modifyFcltyAdit(modifyParams);
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const modifyFcltyAdit = async (modifyParams) => {
  const {data} = await $axios.post('/api/fclty/adit-info', modifyParams);

  if (data == 0) {
    await $alert('오류가 발생하였습니다. 다시 시도해주세요.');
    return false;
  } else
    await $alert('시설추가정보 변경이 완료되었습니다.');

  emits('chng-compt');
  close();
}

const isInit = ref(false);
const init = async () => {
  await getFcltyByFcltySn();
  isInit.value = true;
}

onMounted(async () => {
  try {
    $loading.on();

    await init();
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
})
</script>

<style scoped>

</style>
